import styled from "styled-components";


var click = false

function ShowColapsideContent(event) {

    var colapsideNextSinbling = event.target.nextSibling;

    if(click === false){

    colapsideNextSinbling.style.height = "100%";
    colapsideNextSinbling.style.borderBottom  = "solid 1px rgba(72, 97, 161, 0.3)";

    click = true;

    return;
}

if(click === true){

    colapsideNextSinbling.style.height = "0";
    colapsideNextSinbling.style.borderBottom  = "solid 1px rgba(72, 97, 161, 0.0)";
    click = false;

    return;
    }
}


function ColapsideItemMaster(props) {

    return(

        <ColapsideItem>
            <ColapsideItemHeader onClick={(event) => ShowColapsideContent(event)}>
                <ColapsideItemIcon iconImage={props.IconImage} onClick={(event) => event.stopPropagation()}/> 
                <ColapsideItemTitle onClick={(event) => event.stopPropagation()}> {props.ColapsideItemTitle}</ColapsideItemTitle>
            </ColapsideItemHeader>

            <ColapsideItemContent > 
                {props.ColapsideItemContentDescrition}
            </ColapsideItemContent>
        </ColapsideItem>



    );
}

export default ColapsideItemMaster;


const ColapsideItem = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    transition: .3s ease-in-out;
    //border: solid 1px rgba(72, 97, 161, 0.1);
    //box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.5);
    
`

const ColapsideItemHeader = styled.div`
    display: flex;
    margin: 0;
    padding: 15px 0;
    width: 100%;

    border-bottom: solid 1px rgba(72, 97, 161, 0.3);
    //box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.5);

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }
`

const ColapsideItemIcon = styled.div`
    display: flex;
    margin: 0;
    align-items: center;
    justify-content: space-evenly;
    padding: 0 30px;
    background-image: url(${props => props.iconImage});
    background-repeat: no-repeat;
    background-position: center center;
`

const ColapsideItemTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin: 0;

`

const ColapsideItemContent = styled.div`
    font-size: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    padding: 0px 0px; 
    margin: 0px 0;
    width: 100%;
    overflow: hidden;
    transition: .3s ease-in-out;
    height: 0;
    //box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.5);
    border-bottom: solid 1px rgba(72, 97, 161, 0.0);

`